import React, { useState } from 'react';
import WordleGrid from './wordleGrid';
import SEOHead from './SEOHead';

function GamePage({ user }) {
  const [colorGuideExpanded, setColorGuideExpanded] = useState(false);

  return (
    <div className="main-content">
      <SEOHead 
        title="Play Aminole - Interactive Amino Acid Learning Game"
        description="Play the daily amino acid challenge! Learn biochemistry through an engaging Wordle-style game. Perfect for students studying protein structures and amino acid properties."
        keywords="amino acid game, daily wordle, biochemistry quiz, protein learning, educational game, amino acid quiz"
        url="https://aminole.net/game"
      />
      <img src={`${process.env.PUBLIC_URL}/assets/images/Aminole-Logo.png`} alt="Aminole Logo" className="logo" />
      
      {/* Daily Reset Notification Card */}
      <div className="daily-reset-card">
        <div className="reset-info">
          <span className="reset-icon">🕘</span>
          <div className="reset-text">
            <strong>Daily Word Resets</strong>
            <span>Every day at 9:00 AM EST</span>
          </div>
        </div>
      </div>
      
      <div className="container">
        <div className="game-layout">
          <div 
            className={`color-key color-key-side ${colorGuideExpanded ? 'expanded' : 'collapsed'}`}
            onClick={() => setColorGuideExpanded(!colorGuideExpanded)}
          >
            <h3>
              Color Guide
              <span className="expand-icon">{colorGuideExpanded ? '−' : '+'}</span>
            </h3>
            <div className="color-key-content">
              <div className="key-item">
                <div className="key-color correct"></div>
                <span>Correct letter, correct position</span>
              </div>
              <div className="key-item">
                <div className="key-color present"></div>
                <span>Correct letter, wrong position</span>
              </div>
              <div className="key-item">
                <div className="key-color absent"></div>
                <span>Letter not in word</span>
              </div>
              <div className="key-item">
                <div className="key-color incorrect"></div>
                <span>Incorrect</span>
              </div>
            </div>
          </div>
          
          <div className="game-container">
            <div className="wordle-container">
              <WordleGrid />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GamePage;
